import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 20.419a.9.9 0 0 1-.9-.9V6.752l-4.751 4.99a.9.9 0 0 1-1.298-1.248l6.3-6.6a.9.9 0 0 1 1.298 0l6.3 6.6a.9.9 0 1 1-1.298 1.247L12.9 6.753V19.52a.9.9 0 0 1-.9.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }